export const CONFLICT = 'conflict'
